import { Component } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { switchMap, tap } from "rxjs/operators";
import { CompanyInfo } from "src/app/info/company/company-info";
import { CompanyInfoService } from "src/app/info/company/company-info-service";
import { EventSubscriber } from "src/app/util/event/event-subscriber";
import { GiftCardAlertService } from "../gift-card-alert-service";
import { GiftCardAlert } from "../model/gift-card-alert";
import { GiftCardCustomerOrder } from "../model/gift-card-customer-order";

@Component({
  styleUrls: ["./gift-card-alerts.component.css"],
  templateUrl: "./gift-card-alerts.component.html"
})
export class GiftCardAlertComponent extends EventSubscriber<GiftCardAlert[]>{
  companyInfo!: CompanyInfo
  giftCardAlerts!: GiftCardAlert[];
  customerOrders?: GiftCardCustomerOrder[];

  selectedGiftCardAlert!: GiftCardAlert;

  constructor(
    companyInfoService: CompanyInfoService,
    private giftCardAlertService: GiftCardAlertService,
    private modalService: NgbModal,
  ) {
    super(
      subscriber => this.giftCardAlertService.getEvents(subscriber),
      subscriber => this.giftCardAlertService.disposeEventsSubscription(subscriber),
    );

    companyInfoService.getCompanyInfo().subscribe(companyInfo => this.companyInfo = companyInfo);

    this.subscribe()
      .pipe(tap(giftCardAlerts => this.giftCardAlerts = giftCardAlerts))
      .subscribe();

    giftCardAlertService.refresh()
      .pipe(tap(giftCardAlerts => this.giftCardAlerts = giftCardAlerts))
      .subscribe();
  }

  open(selectedGiftCardAlert: GiftCardAlert, content: any) {
    this.selectedGiftCardAlert = selectedGiftCardAlert;
    this.modalService.open(content).result.then((_) => {
      this.giftCardAlertService.confirm(selectedGiftCardAlert.id)
        .pipe(switchMap(_ => this.giftCardAlertService.refresh()))
        .pipe(tap(giftCardAlerts => this.giftCardAlerts = giftCardAlerts))
        .subscribe();
    });
  }

  showDetails(selectedGiftCardAlert: GiftCardAlert, content: any) {
    this.selectedGiftCardAlert = selectedGiftCardAlert;
    this.customerOrders = undefined;

    this.giftCardAlertService.findCustomerOrders(selectedGiftCardAlert.id)
      .pipe(tap(customerOrders => this.customerOrders = customerOrders))
      .pipe(tap(_ => this.modalService.open(content)))
      .subscribe();
  }

}